<div class="grid grid-3col gap p-2">
    <app-date-input
        id="date"
        [form]="form"
        [prefix]="prefix"
    ></app-date-input>
    <div class="fr-2">
        <app-select-input
            id="warehouseMaterialId"
            [form]="form"
            [label]="prefix + 'fields.warehouseMaterial'"
            [infiniteScroll]="materialsScroll()"
            filterBy="name,code"
            valueKey="id"
            [showClear]="false"
        >
            <ng-template #item let-item>
                {{ item.name }} - {{ item.code }} ({{ item.amountAvailable }})
            </ng-template>
            <ng-template #selectedItem let-item>
                {{ item.name }} - {{ item.code }} ({{ item.amountAvailable }})
            </ng-template>
        </app-select-input>
    </div>

    @if (!form.value.id) {
        <app-number-input
            id="amountIssued"
            [form]="form"
            [prefix]="prefix"
            [min]="0"
        ></app-number-input>
    } @else {
        <app-number-input
            id="amount"
            [form]="form"
            [prefix]="prefix"
            [min]="0"
        ></app-number-input>
    }
    <div class="fr-2">
        <app-input-user-multiselect
            id="workerIds"
            [form]="form"
            [label]="prefix + 'fields.workers'"
            [serviceId]="serviceId()"
            [employment]="EmploymentParentGroupEnum.DIRECT_CARE"
        ></app-input-user-multiselect>
    </div>
    @if (!form.value.id) {
        @if (workOperation) {
            <app-number-input
                id="amountReceipt"
                [form]="form"
                [prefix]="prefix"
                [min]="0"
            ></app-number-input>
        } @else {
            <app-number-input
                id="amountReturned"
                [form]="form"
                [prefix]="prefix"
                [min]="0"
            ></app-number-input>
        }
    }
    <div></div>
</div>
<div class="grid p-2 grid-1col gap-2">
    <app-text-area-input
        id="description"
        [form]="form"
        [prefix]="prefix"
    ></app-text-area-input>
</div>
